import { connect } from "react-redux";
import { getRacesForTournament, getTicketsForTournament, getTournament, getUsers } from "../selectors";
import TvLeaderboardBasic from "../components/tv-leaderboard-basic";
import LoadingModal from "../components/loading-modal";
import React from "react";
import { tournamentSubscribe } from "../actions/tournament";

class TvBoardBasic extends React.PureComponent {
  constructor(props) {
    super(props);

    var { match, tournamentSubscribe: onTournamentSubscribe } = props;
    onTournamentSubscribe(match.params.id);
  }

  componentDidUpdate({ tournament }) {
    var { match, tournamentSubscribe: onTournamentSubscribe } = this.props;
    if (this.didTournamentChange(tournament)) {
      onTournamentSubscribe(match.params.id);
    }
  }

  didTournamentChange(t) {
    var { match, tournament } = this.props;
    return tournament !== t &&
      t !== undefined &&
      tournament !== undefined &&
      t.get("id") !== parseInt(match.params.id);
  }


  render() {
    var { races, tickets, tournament, users } = this.props;
    var hideIntercom = "#intercom-container { display: none; }";

    if (tournament === undefined) {
      return (<LoadingModal />);
    }
    var standingsText = window.env.brandName + ".com";
    var tournamentStatus = tournament.get("status");

    if (tournamentStatus === "final") {
      standingsText = "Final Standings";
    } else if (tournamentStatus === "cancelled") {
      standingsText = "Contest Cancelled";
    } else if (tournamentStatus === "running") {
      var lastFinalRace = races.filter((r) => r.get("status") === "final").last();
      if (lastFinalRace !== undefined) {
        standingsText = "Standings After " + lastFinalRace.get("track_name") + " Race " + lastFinalRace.get("race_number");
      } else {
        standingsText = "Tournament in progress";
      }
    } else if (races.size > 0) {
      standingsText = "Contest Starts " + races.first().get("track_name") + " Race " + races.first().get("race_number");
    }

    return (
      <div className="leaderboard-grid leaderboard-grid--is-basic">
        <div className="l-wrapper">
          <div className="l-content">
            <h1 className="leaderboard-grid_heading">
              {tournament.get("name")}
            </h1>

            <h1 className="leaderboard-grid_heading">
              {window.env.brandName}
              .com
            </h1>

            <TvLeaderboardBasic tickets={tickets} tournament={tournament} users={users} />

            <h2 className="leaderboard-grid_sub">
              {standingsText}
            </h2>
          </div>
        </div>

        <style>
          {hideIntercom}
        </style>
      </div>
    );
  }
}

function select(state, props) {
  return {
    races: getRacesForTournament(state, props),
    tickets: getTicketsForTournament(state, props),
    tournament: getTournament(state, props),
    users: getUsers(state)
  };
}

export default connect(select, { tournamentSubscribe })(TvBoardBasic);
